import * as types from './types';

const initialState = {
  account: null,
  fetchPending: false,
  fetchSuccess: false,
  fetchFailure: false,
};

const authFetch = () => ({
  ...initialState,
  fetchPending: true,
});

const authSuccess = (state, payload) => ({
  ...initialState,
  account: payload,
  fetchSuccess: true,
});

const authFailure = () => ({
  ...initialState,
  fetchFailure: true,
});

export default(state = initialState, action) => {
  switch (action.type) {
    case types.AUTH_DATA_FETCH:
      return authFetch();
    case types.AUTH_DATA_SUCCESS:
      return authSuccess(state, action.payload);
    case types.AUTH_DATA_FAILURE:
      return authFailure();
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/auth/index.js